import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute, LoginPage, AppAuthProviderWrapper, Auth0AuthBridge } from '@aimsos/auth';
import ShellLayout from './shell/ShellLayout.jsx';
import WorkspaceGate from './shell/WorkspaceGate.jsx';
import WorkspacePicker from './shell/WorkspacePicker.jsx';
import GovernanceEmbed from './apps/GovernanceEmbed.jsx';
import DataStudioEmbed from './apps/DataStudioEmbed.jsx';
import AgenticStudioEmbed from './apps/AgenticStudioEmbed.jsx';
import UserMgmtEmbed from './apps/UserMgmtEmbed.jsx';
import WorkQueuesEmbed from './apps/WorkQueuesEmbed.jsx';
import PeopleAccessEmbed from './apps/PeopleAccessEmbed.jsx';
import InvitationsEmbed from './apps/InvitationsEmbed.jsx';
import DashboardsEmbed from './apps/DashboardsEmbed.jsx';
import WidgetsEmbed from './apps/WidgetsEmbed.jsx';
import WorkspacesEmbed from './apps/WorkspacesEmbed.jsx';
import AgentsEmbed from './apps/AgentsEmbed.jsx';
import AdminStudioEmbed from './apps/AdminStudioEmbed.jsx';
import UnifiedProfilesEmbed from './apps/UnifiedProfilesEmbed.jsx';
import NotFoundPage from './shell/NotFoundPage.jsx';
import ShellDashboard from './shell/ShellDashboard.jsx';
import Tasks from './domains/tasks';

const App = () => (
  <AppAuthProviderWrapper>
    <Auth0AuthBridge>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        {/* Public on purpose (CT-5567): the invitee opens the emailed link before having a session. */}
        <Route path="/invitations/*" element={<InvitationsEmbed />} />
        <Route
          path="/select-workspace"
          element={
            <ProtectedRoute>
              <WorkspacePicker />
            </ProtectedRoute>
          }
        />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <WorkspaceGate>
                <ShellLayout />
              </WorkspaceGate>
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<ShellDashboard />} />
          <Route path="governance/*" element={<GovernanceEmbed />} />
          <Route path="data-studio/*" element={<DataStudioEmbed />} />
          <Route path="agentic-studio/*" element={<AgenticStudioEmbed />} />
          <Route path="users/*" element={<UserMgmtEmbed />} />
          <Route path="work-queues/*" element={<WorkQueuesEmbed />} />
          <Route path="people-access/*" element={<PeopleAccessEmbed />} />
          <Route path="dashboards/*" element={<DashboardsEmbed />} />
          <Route path="widgets/*" element={<WidgetsEmbed />} />
          <Route path="workspaces/*" element={<WorkspacesEmbed />} />
          <Route path="agents/*" element={<AgentsEmbed />} />
          <Route path="admin-studio/*" element={<AdminStudioEmbed />} />
          <Route path="unified-profiles/*" element={<UnifiedProfilesEmbed />} />
          <Route path="tasks/*" element={<Tasks />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Auth0AuthBridge>
  </AppAuthProviderWrapper>
);

export default App;
